import React from "react"
import { SourcePropsWithMsgIds } from "../../props/sourceprops";
import { BibleReferenceProps } from "../../props/biblereferenceprops";
import SourcesLink from "../source/SourcesLink"
import BubbleToUser from "./BubbleToUser"
import { HcContext } from "../../types/hccontext";
import BibleLink from "../source/BibleLink";
import { imgToFirebaseUrl2, onErrorImageHandler } from '../util/imagefallbacks'

interface BubblesToUserInChatProps {
    language: string;
    hcContext: HcContext;
    sources?: SourcePropsWithMsgIds[];
    bibleReferences?: BibleReferenceProps[];
    children: React.ReactNode;
}


const BubbleToUserInChat: React.FC<BubblesToUserInChatProps> = ({ language, hcContext, sources, bibleReferences, children }) => {

    return (
        <table width="100%">
            <thead className="visually-hidden"><tr><th></th></tr></thead>
            <tbody>
                <tr>
                    <td width="4%"></td>
                    <td width="96%" style={{ paddingTop: '7px' }}>
                        <div>
                            <BubbleToUser hcContext={hcContext}>{children}</BubbleToUser>
                            {
                                sources !== undefined &&
                                <>
                                    <div style={{ display: 'inline-block', marginLeft: 14, padding: 5, marginRight: 30, backgroundColor: hcContext.getBotBubbleBackgroundColor() }}>
                                        <SourcesLink language={language} sources={sources} />
                                    </div><br />
                                </>
                            }
                            {
                                bibleReferences !== undefined &&
                                <div style={{ display: 'inline-block', marginLeft: 14, padding: 5, marginRight: 30, backgroundColor: hcContext.getBotBubbleBackgroundColor() }}>
                                    {bibleReferences.length > 0 &&
                                        <span style={{ display: 'block', paddingTop: '3px' }}>
                                            <img src={imgToFirebaseUrl2("sources/bible_logo.png")} alt="Bible logo" className="hc-source-icon" onError={(e) => onErrorImageHandler(e, "sources/bible_logo.png")} style={{ borderRadius: 100 }} />
                                            {
                                                bibleReferences.map((item, index) => (
                                                    <span key={`bible-ref-link-${index}`}>
                                                        <BibleLink language={language} chapter={item.chapter} verses={item.verses} reference={item.ref} />
                                                        {index < bibleReferences.length - 1 && ', '}
                                                    </span>
                                                ))
                                            }
                                        </span>
                                    }
                                </div>
                            }
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default BubbleToUserInChat



